import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import { css } from '@emotion/react';
import { useAppSelector } from '../../../redux/store';
import { range } from '../../../utils/utils';
import { MttStagingSubSection } from './mttStagingSubSection';
import { MttStagingTableDisplay } from './mttStagingTableDisplay';
const CONTAINER_CSS = css `
  display: flex;
  flex-direction: column;
  gap: 2px;
  /* hide drop shadows with overflow: hidden: */
  overflow: hidden;
  padding-bottom: 20px;
`;
export const MttStagingTablesSubSectionContainer = () => {
    const numMttStagingTables = useAppSelector((state) => state.mttStaging.mttStagingTables.length);
    if (!numMttStagingTables) {
        return null;
    }
    return (_jsx(MttStagingSubSection, { title: 'Tables', children: _jsx("section", { "aria-label": 'tables', css: CONTAINER_CSS, children: range(numMttStagingTables).map((i) => (_jsx(MttStagingTableDisplay, { mttStagingTableIndex: i }, i))) }) }));
};
